import React from 'react';
import NewColumns from './NewColumns'
import FiltersForm from './FiltersForm'
import RemoveColumn from './RemoveColumn'
import ManageCounters from './ManageCounters'

class Collapsible extends React.Component {
  constructor () {
    super()
    this.state = {
      showBatchUpdate: false,
      showNewColumns: false,
      showManageCounters: false,
      showFilters: false,
      showRemoveColumn: false
    }
  }

  hide() {
    this.setState({
      showBatchUpdate: false,
      showNewColumns: false,
      showManageCounters: false,
      showFilters: false,
      showRemoveColumn: false
    })
    this.props.resetCollapsible()
  }

  getFiltered(filters) {
    this.props.getFiltered(filters)
  }

  render() {

    const { hasActive, toggleMore, report_id, columns } = this.props
    const { showBatchUpdate, showNewColumns, showFilters, showRemoveColumn, showManageCounters } = this.state

    const hasActiveClass = hasActive ? "active" : ""
    const collapsibleIcon = hasActive ? "keyboard_arrow_down" : "keyboard_arrow_right"

    const batchUpdateAction = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: true,
          showNewColumns: false,
          showFilters: false,
          showManageCounters: false,
          showRemoveColumn: false
        })
      }}><i className="material-icons tiny">mode_edit</i>Filters & Batch Options</a>
    )

    const add_columns = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: false,
          showNewColumns: true,
          showFilters: false,
          showManageCounters: false,
          showRemoveColumn: false
        })
      }}><i className="material-icons tiny">view_column</i>Add New Column(s)</a>
    )

    const remove_columns = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: false,
          showNewColumns: false,
          showFilters: false,
          showManageCounters: false,
          showRemoveColumn: true
        })
      }}><i className="material-icons tiny">delete</i>Remove a Column</a>
    )

    const manage_counters = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: false,
          showNewColumns: false,
          showFilters: false,
          showRemoveColumn: false,
          showManageCounters: true,
        })
      }}><i className="material-icons tiny">settings_ethernet</i>Counter Thresholds</a>
    )

    const actionsClass = ( showFilters || showBatchUpdate ) ? "hide " : "entryAdditionalActions"
    const flexClass = ( showFilters || showBatchUpdate ) ? "" : "flex"

    return (
      <div>
        <ul id="collapsible_ul" className="collapsible">
          <li className={ hasActiveClass }>
            <div className="collapsible-header" onClick={(e) => {
              toggleMore()
            }}>
              <i className="material-icons">{ collapsibleIcon }</i>More Actions
            </div>
            <div className="collapsible-body">
              <div className={flexClass}>
                <div className={actionsClass}>
                  { batchUpdateAction }
                  { add_columns }
                  { manage_counters }
                  { remove_columns }
                </div>
                <div className={`${showBatchUpdate ? 'full ' : ''}formContainer`}>
                  <NewColumns
                    report_id={report_id}
                    columns={columns}
                    isHidden={ showNewColumns===false }
                    hide={this.hide.bind(this)}
                  />
                  <FiltersForm
                    report_id={report_id}
                    columns={columns}
                    isHidden={ showFilters===false && showBatchUpdate === false }
                    hide={this.hide.bind(this)}
                    getFiltered={this.getFiltered.bind(this)}
                    resetCollapsible={this.props.resetCollapsible.bind(this)}
                    hasUpdate={showBatchUpdate}
                    account_id={this.props.account_id}
                  />
                  <RemoveColumn
                    report_id={report_id}
                    columns={columns.filter(a => a.hidden !== true)}
                    isHidden={ showRemoveColumn===false }
                    hide={this.hide.bind(this)}
                  />
                  <ManageCounters
                    report_id={report_id}
                    columns={columns.filter(c=>c.editable === true).filter(c=> !c.key.match(/length$/) && !c.key.match(/width$/) )}
                    isHidden={ showManageCounters===false }
                    hide={this.hide.bind(this)}
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    )
  }
}

export default Collapsible;



// WEBPACK FOOTER //
// ./src/js/components/Collapsible.js